import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getGuildInWeb,
  getPlayerInWeb,
} from "../../../store/reducers/reducerWeb";
import { checkGuildType } from "../../tools/checkGuildType";
import GetPlayerOnlineForGuildInfo from "../../tools/GetPlayerOnlineForGuildInfo";
import GuildMarker from "../../tools/guildMarker";
import Scrollto from "../../tools/scrollTo";

import "./Guild.scss";

const Guild = () => {
  const guild = useSelector((data) => data.reducerWeb.Guild.data);
  const [online, setOnline] = useState([]);
  const navigate = useNavigate();
  const [state, setState] = useState();
  const dispatch = useDispatch();
  const params = useParams();
  let tt = [];

  useEffect(() => {
    const GetGuildInfo = async () => {
      try {
        dispatch(
          await getGuildInWeb({
            guildname: params?.guildname,
          })
        ).then(function (response) {});
      } catch (e) {
        console.log(e);
      }
    };

    GetGuildInfo();
  }, [params]);

  if (guild?.GuldInfo && guild?.GuldInfo.length == 0) {
    return <div className="containerGuildInfo">No Guild Found!</div>;
  }

  return (
    <div className="containerGuildInfo">
      <Scrollto position={200} />
      <div className="containerGuildInfoTitle">
        <div>
          <GuildMarker
            mark={guild?.GuldInfo && guild?.GuldInfo[0]?.G_Mark}
            size={100}
          />
        </div>

        <div className="subContainerGuildInfoTitle">
          {/* <div className="GuilInfoGuildName">
            {guild?.GuldInfo && guild?.GuldInfo[0]?.G_Name}
          </div> */}
          <div>Guild Name: {guild?.GuldInfo && guild?.GuldInfo[0]?.G_Name}</div>
          <div>Guild Master: {guild?.GuldInfo && guild?.GuldInfo[0]?.Name}</div>

          <div>
            Guild Number players: {guild?.GuldInfo && guild?.GuldInfo.length}
          </div>
          <div className="GuilInfoAlliance">
            Alliance Guilds: &nbsp;
            {JSON.stringify(guild?.Alliance) === "{}" && "N/A"}
            {guild?.Alliance &&
              guild?.Alliance?.Alliance?.map((guild) => {
                if (params?.guildname != guild.G_Name) {
                  return (
                    <div
                      onClick={() => navigate(`/guild/${guild.G_Name}`)}
                      className="GuilInfoAllianceGuildName newCursor"
                    >
                      {guild.G_Name}, &nbsp;
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </div>
      <hr style={{ width: "100%", marginTop: "40px", opacity: "0.4" }} />
      {/* <td>ONLINE: {tt.map((o) => o.online)}</td> */}
      {/* {console.log(tt.map((t) => t))} */}
      <table className="TableGuildInfo">
        <tbody>
          {guild?.GuldInfo &&
            guild?.GuldInfo.map((guild, i) => (
              <tr key={guild.Name}>
                <td>{i + 1}</td>
                <td
                  className="newCursor"
                  onClick={() => navigate(`/player/${guild.Name}`)}
                >
                  {guild.Name}
                </td>
                <td>{checkGuildType(guild.G_Status)}</td>
                <GetPlayerOnlineForGuildInfo name={guild.Name} />
                {/* {console.log(online.map((o) => o.online))} */}
              </tr>
            ))}

          {/* <td>Online {JSON.stringify(online[0]?.Online)} dd</td> */}
        </tbody>
      </table>
    </div>
  );
};

export default Guild;
